export const characterLimitSmall: number = 30;
export const characterLimitMedium: number = 50;
export const characterLimitLarge: number = 70;